import {Button, IconButton} from "@mui/material";
import {useEffect} from "react";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import {rolesColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import LoadingContent from "../components/ui/LoadingContent";

const Roles = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest({baseUrl: "/roles", resource: "roles"});

  // Hook para el diálogo de confirmación
  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    try {
      await remove(id);
      await list();
    } catch (error) {
      console.error("Error al eliminar el rol:", error);
    }
  });

  useEffect(() => {
    (async () => {
      try {
        await list();
      } catch (error) {
        console.error("Error al cargar los roles:", error);
      }
    })();
    // eslint-disable-next-line
  }, []);

  const handleRoleClick = (role) => {
    if (!role?.id) {
      console.error("Error: No se encuentra el rol");
      return;
    }
    navigate(`/role-form`, {state: {id: role?.id}});
  };

  const handleOpenDeleteDialog = (id) => {
    const found = Array.isArray(data) ? data.find((role) => role.id === id) : null;
    openDialog(id, found?.name || "");
  };

  const columns = [
    ...rolesColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              handleOpenDeleteDialog(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <>
      <Window
        title={"Roles"}
        topRightButtons={
          <Button
            variant="contained"
            color="primary"
            startIcon={<FiPlus />}
            onClick={() => {
              navigate(`/role-form`);
            }}
          >
            Nuevo Rol
          </Button>
        }
      >
        {loading ? (
          <LoadingContent />
        ) : (
          <ListView columns={columns} data={data} loading={loading} onRowClick={handleRoleClick} />
        )}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="rol"
        entityLabel={itemName}
      />
    </>
  );
};

export default Roles;
